/**
 * Client-side validation for a CSP whitelist domain (GR-3612). Mirrors
 * ValidationHelpers.IsValidCspSourceHost in core, which is authoritative:
 * a hostname ("static.hotjar.com") or wildcard host ("*.hotjar.com"), no
 * scheme, port or path, at least two labels (rejecting bare "*", bare TLDs
 * and over-broad wildcards like "*.com"), max 253 characters.
 */
const CSP_DOMAIN_PATTERN =
  /^(\*\.)?([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/;

export const isValidCspDomain = (value: string): boolean => {
  const domain = (value || '').trim().toLowerCase();
  return domain.length > 0 && domain.length <= 253 && CSP_DOMAIN_PATTERN.test(domain);
};

export const normalizeCspDomain = (value: string): string =>
  (value || '').trim().toLowerCase();
